
import { Link } from 'react-router-dom'
import bgImg from '../assets/children-2142646_1280.jpg'
import { HOME } from '../constants/constants'

const NotFound = () => {
    return (
        <>
            <section bgImg
                style={{
                    background: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${bgImg})`,
                    backgroundSize: "cover",
                    objectFit: "cover",
                    backgroundAttachment: 'fixed',
                    height: '100vh',
                    width: '100%',
                }}
                className="flex justify-center items-center gap-3 text-center text-white">
                <div>
                    <h1 className="text-8xl t text-white font-bold py-4">4<span className="text-orange-600">0</span>4</h1>
                    <p className='text-4xl py-2'>
                        <b>Oops</b>! Page not found
                    </p>
                    <p className='text-[14px] py-2'>Cette page que tu recherches ne peut pas etre trouvé</p>
                    <br />
                    <Link to={HOME} className="border-white text-center border-2 lowercase px-4 py-2 rounded-md">retourner à l'Accueil</Link>
                </div>
            </section>
            {/* <div>
                <h2>Want to donate? it's time to show your huminity</h2>
                <button>Donate now</button>
            </div> */}
        </>
    )
}

export default NotFound